/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import type { RichText } from './rich-text'

/* TypeScript */
export type RichTextApiProps = {
  technicalName?: string
  richText: RichText | Record<string, never>
}

/* Schemas */
export const RichTextApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  richText: LooseRichTextSchema,
})

/* Schemas validation */
type TestRichTextProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<RichTextApiProps>,
    z.infer<typeof RichTextApiPropsSchema>
  >
>
